import { OpportunityApi } from './domains/opportunity';
import { ApplicationApi } from './domains/application';
import { AuthApi } from './domains/auth';
import { DashboardApi } from './domains/dashboard';
import { ProfileApi } from './domains/profile';
import { VolunteerApi } from './domains/volunteer';

class Api {
    public opportunities: OpportunityApi;
    public applications: ApplicationApi;
    public auth: AuthApi;
    public dashboard: DashboardApi;
    public profile: ProfileApi;
    public volunteer: VolunteerApi;

    constructor() {
        this.opportunities = new OpportunityApi();
        this.applications = new ApplicationApi();
        this.auth = new AuthApi();
        this.dashboard = new DashboardApi();
        this.profile = new ProfileApi();
        this.volunteer = new VolunteerApi();
    }

    // Token management
    setToken(token: string | null): void {
        if (token) {
            this.opportunities.setToken(token);
            this.applications.setToken(token);
            this.auth.setToken(token);
            this.dashboard.setToken(token);
            this.profile.setToken(token);
            this.volunteer.setToken(token);
        } else {
            this.opportunities.setToken(null);
            this.applications.setToken(null);
            this.auth.setToken(null);
            this.dashboard.setToken(null);
            this.profile.setToken(null);
            this.volunteer.setToken(null);
        }
    }
}

export const api = new Api();
